export default __webpack_public_path__ + "static/media/psoriasis-frontp.435c046b.pdf";